import { HistoricalMedicalLeave } from '@dreryk/egabinet-ezla-frontend-api';

import { StatusIcon, StatusIconTooltip, StatusIconType } from '@dreryk/react-components';

import { historicalLeavesTranslationKeys } from '../../../../translations';
import { isInsuredInPoland } from '../../common/common.utils';

const PositiveStatusIcon = (): JSX.Element => {
   return (
      <StatusIconTooltip tooltipText={historicalLeavesTranslationKeys.payerAccountExists} testId={'payerAccountExists'}>
         <StatusIcon type={StatusIconType.POSITIVE} testId='positiveStatus' />
      </StatusIconTooltip>
   );
};

const NegativeStatusIcon = (): JSX.Element => {
   return (
      <StatusIconTooltip
         tooltipText={historicalLeavesTranslationKeys.payerAccountNotExists}
         testId={'payerAccountNotExists'}
      >
         <StatusIcon type={StatusIconType.NEGATIVE} testId='negativeStatus' />
      </StatusIconTooltip>
   );
};

type PueAccountStatusProps = {
   readonly historicalMedicalLeave: HistoricalMedicalLeave;
};

const PueAccountStatus = (props: PueAccountStatusProps): JSX.Element | null => {
   const { historicalMedicalLeave } = props;
   if (isInsuredInPoland(historicalMedicalLeave.insuranceType)) {
      return historicalMedicalLeave.payerPueAccount ? <PositiveStatusIcon /> : <NegativeStatusIcon />;
   }

   return null;
};

export { PueAccountStatus };
